import React, { useMemo } from 'react';
import { ExplanationText } from '../../../../../components/ExplanationText';
import { getEstimatedProductionTime } from './getEstimatedProductionTime';
export const OnDemandListing = ({ product }) => {
    const { from, to } = useMemo(() => getEstimatedProductionTime(product), [product]);
    const PRODUCTION_TIME_TEXT = from === to ? from : `${from}-${to}`;
    return (React.createElement(ExplanationText, { title: "On demand", subtitle: `This product is produced to order. Orders ship within ${PRODUCTION_TIME_TEXT} days of being placed.` }));
};
